import Accordion from '@components/Accordion';
import Button from '@components/Button';
import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import useGiftBox from '@hooks/gift/useGiftBox';
import { GiftBoxType, GiftItemType } from '@models/gift';
import { Link } from '@router/Link';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';

import GiftHeader from './components/GiftHeader';
import GiftItem from './components/GiftItem';
import GiftMessage from './components/GiftMessage';
import UseInfo from './components/UseInfo';

interface Params {
    giftBoxItemId: string;
    giftItemType: GiftItemType;
}
const GiftReceivedActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { giftBoxItemId, giftItemType } = params;
  const giftBox = useGiftBox(giftBoxItemId, {
    giftItemType, giftBoxType: GiftBoxType.RECEIVED,
  });
  const contents = <Fragment>
        <GiftHeader/>
        {giftBox && (
            <GiftItem giftBox={giftBox}/>
        )}
        {giftBox?.giftItemType === 'PRODUCT' && (
            <UseInfo/>
        )}
        <GiftMessage/>
        <Divider/>
        <Accordion title='유의사항' >

        </Accordion>
    </Fragment>;
  return (
        <AppScreen>
            {giftBox?.giftItemType === 'PRODUCT' ? (
                <Column fullWidth>
                    <Header title='받은 선물' />
                    {contents}
                </Column>
            ) : (
                // {/* href='/prepaid-card' */}
                <CtaLayout header={<Header title='받은 선물' />}
                           footer={<Link activityParams={{}}
                                         activityName='MainActivity' >
                               <Button fullWidth>
                                   사용하러 가기
                               </Button>
                           </Link>}
                           noFooterBorder>
                    {contents}
                </CtaLayout>
            )}
        </AppScreen>
  );
};

export default GiftReceivedActivity;
